import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 32px;
  margin-top: 24px;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
  
  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Avatar = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
`;

export const AvatarPlaceholder = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.v2.colors.neutral.highExtraLight};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${({ theme }) => theme.v2.colors.neutral.highMedium};
  
  svg {
    color: ${({ theme }) => theme.v2.colors.neutral.lowMedium};
  }
`;

export const TextWrapper = styled.div`
  display: block;
  flex-direction: column;
  flex: 1;
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.v2.colors.neutral.lowDark};
  font-family: ${({ theme }) => theme.v2.font.family.primary};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const ButtonWrapper = styled.div`
  padding-top: 16px;
  display: flex;
  gap: 12px;
  margin-left: auto;
  
  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    margin-left: 0;
  }
`;

export const RemoveButton = styled.div`
  display: inline-block;
`;

export const HiddenInput = styled.input`
  display: none;
`;
